import React from 'react';
import { useLocation } from 'react-router-dom';
import { EventTracker } from '../components/GoogleAnalytics';
import { Row, Col, Container, Image, Button } from 'react-bootstrap';
import '../styles/context.page.scss';
import BigText from '../components/BigText';

export default function Context({ l }) {
    return (
        <>
            {l.stats &&
                <Container fluid className="bg-primary py-2 py-md-5">
                    <Container>
                        <h1 className="h4 bold text-uppercase text-white">{l.whyImportant}</h1>
                        <Stats l={l} />
                    </Container>
                </Container>
            }
            <Container fluid className="bg-light">
                <Container>
                    <Community l={l} />
                </Container>
            </Container>
            <Container className="pb-5">
                <BigText text={l.call} />
                <Row>
                    <Col xs={12} md={7} className="">
                        <p dangerouslySetInnerHTML={{ __html: l.ask1 }}></p>
                    </Col>
                    <Col xs={12} md={7} className="mt-2">
                        <p dangerouslySetInnerHTML={{ __html: l.ask2 }}></p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className="bg-primary">
                <Container>
                    <Download l={l} />
                </Container>
            </Container>
        </>
    )
}

function Stats({ l }) {
    return (
        <>
            {l.stats.map((stat, i) => (
                <Row className="mt-4">
                    <Col xs={12} md={4}>
                        <span className="text-secondary stat-number">
                            {stat.stat}
                        </span>
                    </Col>
                    <Col cs={12} md={7}>
                        <span className="text-white stat-text">{stat.text}</span>
                    </Col>
                </Row>
            ))}
        </>
    )
}

function Community({ l }) {
    return (
        <Row className="py-2 py-md-5">
            <Col xs={12} md={6}>
                <h2 className="h4 bold text-uppercase text-primary">{l.whyNeighborhood}</h2>
                <p className="" dangerouslySetInnerHTML={{ __html: l.communityContext }}></p>
            </Col>
            <Col xs={12} md={6} className="align-self-start">
                <Image fluid className="Context__community-image" src={l.mapSrc} alt={l.mapAlt} />
            </Col>
        </Row>
    )
}

function Download({ l }) {
    const currentLocation = useLocation().pathname;
    const category = 'download';
    const action = `downloaded challenge manual on ${currentLocation}`;
    if (!l.challengeManualUrl) {return null}
    return (
        <Row className="justify-content-center text-center py-2 py-md-5">
            <Col xs={12} md={6}>
                <div className="h3 bold text-white">
                    {l.downloadTitle}
                </div>
                <div>
                    <Button href={l.challengeManualUrl}
                        target="_blank"
                        variant="secondary"
                        className="mt-1 mt-md-3 text-uppercase"
                        onClick={() => EventTracker(category, action)}>
                        {l.downloadButtonText}
                    </Button>
                </div>
            </Col>
        </Row>
    )
}